module.exports = __webpack_public_path__ + "static/img/purchase-together.f7777fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/purchase-together.jpg
// module id = 1RUN
// module chunks = 1